var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b',{staticClass:"smoo-btn",attrs:{"title":_vm.title}},[(_vm.custom)?_c('span',{class:{ [_vm.btn]: true }},[_vm._v(_vm._s(_vm.btn))]):_vm._e(),(!_vm.custom)?_c('b-icon',{attrs:{"icon":_vm.icon,"title":_vm.title}}):_vm._e(),(!_vm.custom)?_c('img',{staticClass:"alt",attrs:{"alt":_vm.title}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }